module.exports = __webpack_public_path__ + "static/img/yytx15.7f2cda5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx15.png
// module id = 795
// module chunks = 0